import { useState } from 'react'

export interface FloatingActionMenuProps {
  plan: string
  areFeedbacksPublished: boolean
  areOpeningHoursPublished: boolean
  isChatWithAIPublished: boolean
}

enum Buttons {
  OpeningHours = 'Opening Hours',
  Feedback = 'Feedback',
  Chatbot = 'Chatbot',
}

export const useFloatingActionMenu = (props: FloatingActionMenuProps) => {
  const [showOpeningHoursBox, setShowOpeningHoursBox] = useState(false)
  const [showFeedbackBox, setShowFeedbackBox] = useState(false)
  const [showChatbotBox, setShowChatbotBox] = useState(false)

  const handleBtnClick = (btn: Buttons) => {
    switch (btn) {
      case Buttons.OpeningHours: {
        setShowOpeningHoursBox(true)
        break
      }
      case Buttons.Feedback: {
        setShowFeedbackBox(true)
        break
      }
      case Buttons.Chatbot: {
        setShowChatbotBox(true)
      }
    }
  }

  return {
    ...props,
    Buttons,
    showOpeningHoursBox,
    showFeedbackBox,
    showChatbotBox,
    setShowOpeningHoursBox,
    setShowFeedbackBox,
    setShowChatbotBox,
    handleBtnClick,
  }
}
